import PropTypes from "prop-types"
import { Flex, Form, Input } from "antd"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"
import styles from "./index.module.css"

const TIP_PRESETS = ["10", "15", "20"]

const TipSection = ({ baseAmount, onTipChange, disablePresets }) => {
  const [selected, setSelected] = useState("none")
  const { t } = useTranslation()
  const form = Form.useFormInstance()

  const handlePresetClick = (preset) => {
    setSelected(preset)
    if (preset === "none") {
      form.setFieldValue("tipCustomAmount", "")
      form.validateFields(["tipCustomAmount"])
      onTipChange(0)
    } else {
      const tip = (baseAmount * Number(preset)) / 100
      form.setFieldValue("tipCustomAmount", tip.toFixed(2))
      form.validateFields(["tipCustomAmount"])
      onTipChange(tip)
    }
  }

  const handleCustomChange = (e) => {
    setSelected("custom")
    const num = Number.parseFloat(e.target.value)
    onTipChange(Number.isNaN(num) || num < 0 ? 0 : num)
  }

  return (
    <Flex vertical gap={spacings.S} className="mt-m">
      <Text className={styles.label}>{t("client.payment.collect.add_a_tip")}</Text>
      <Flex gap={spacings.S} wrap>
        {TIP_PRESETS.map((preset) => (
          <button
            key={preset}
            type="button"
            className={selected === preset ? styles.presetButtonActive : styles.presetButton}
            onClick={() => handlePresetClick(preset)}
            disabled={disablePresets}
          >
            {preset}%
          </button>
        ))}
        <button
          type="button"
          className={selected === "none" ? styles.presetButtonActive : styles.presetButton}
          onClick={() => handlePresetClick("none")}
        >
          None
        </button>
      </Flex>
      <Form.Item
        name="tipCustomAmount"
        className={styles.customInput}
        preserve={false}
        rules={[
          {
            validator: (_, value) => {
              if (!value && value !== 0) return Promise.resolve()
              const num = Number.parseFloat(value)
              if (!Number.isNaN(num) && num < 0) {
                return Promise.reject(new Error("Tip amount cannot be negative"))
              }
              return Promise.resolve()
            }
          }
        ]}
      >
        <Input prefix="$" type="number" min="0" placeholder={t("client.payment.collect.custom_tip")} onChange={handleCustomChange} />
      </Form.Item>
    </Flex>
  )
}

TipSection.propTypes = {
  baseAmount: PropTypes.number.isRequired,
  onTipChange: PropTypes.func.isRequired,
  disablePresets: PropTypes.bool
}

export default TipSection
